import { kebabCase } from "lodash";
import { observer } from "mobx-react";
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { BAGS } from "../../../shared/bags";
import { COLORS } from "../../../shared/stateColors";
import { MainStore } from "../../../stores/MainStore";
import Image from "../../Image";
import Label from "../../Label";
import TabView from "../../TabView";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  intl: any;
}

interface IState { }

@observer
class DetailsOverview extends Component<IProps, IState> {
  render() {
    const { store, intl } = this.props;
    const { selectedState } = store;
    if (!selectedState) return null;
    const stateLanguages = selectedState.workingLanguages || [];
    const selectedStateName = selectedState.name;
    const selectedStateNameLowerCase = kebabCase(selectedStateName);

    /// get state colors
    const stateColor = COLORS.filter(
      c => c.stateName === selectedStateNameLowerCase
    )[0];

    const workingInCountryLabel = `${intl.formatMessage({
      id: `working-in-country`
    })} ${intl.formatMessage({
      id: `${selectedState.id}-label`
    })}`;

    const isBusinessPracticeActive = selectedState.businessPractice


    return (
      <div className={classes.DetailsOverview}>
        <Label big bold id={"details.overview"} />
        <TabView
          store={store}
          customColor={stateColor ? stateColor.colors.primary : ""}
        >
          <div title={workingInCountryLabel}>
            <Label left medium text={selectedState.workingIn} />
          </div>
          <div
            title={
              isBusinessPracticeActive === true
                ? intl.formatMessage({
                  id: `working-language-${selectedState.id}`
                })
                : intl.formatMessage({
                  id: "working-language"
                })
            }
            className={classes.WorkingLanguageWrapper}
          >
            <div
              className={[
                classes.Left,
                stateLanguages.length === 0 ? classes.FullSize : ""
              ].join(" ")}
            >
              <div className={classes.BagImage}>
                {isBusinessPracticeActive === true ? null : (
                  <Image big src={BAGS["all"]} alt={"Language Image"} />
                )}
                {isBusinessPracticeActive === true ? (
                  <Label
                    left
                    medium
                    light
                    text={`${selectedState.mainLanguage}`}
                  />
                ) : selectedState.id === "uganda" ||
                  selectedState.id === "southafrica" ||
                  selectedState.id === "germany" ? (
                      <Label big light text={`${selectedState.mainLanguage}`} />
                    ) : (
                      <Label big light text={`${selectedState.mainLanguage}`} />
                    )}
              </div>
            </div>
            {stateLanguages && stateLanguages.length > 0 && (
              <div className={classes.Right}>
                <div className={classes.Languages}>
                  <Label
                    /* small */
                    light
                    left
                    id={`details.workinglanguage.additionals-pre-${selectedState.id}`}
                  />
                  {stateLanguages.map((lang: string) => {
                    return (
                      <Label
                        left
                        bold
                        medium
                        text={lang}
                        className={classes.LanguageItem}
                        key={lang}
                      />
                    );
                  })}
                  <Label
                    /* small */
                    light
                    left
                    id={`details.workinglanguage.additionals-post-${selectedState.id}`}
                  />
                </div>
              </div>
            )}
          </div>
          {selectedState.businessPracticeInternational === true ? (
            <div
              title={intl.formatMessage({
                id: `international-community-${selectedState.id}`
              })}
            >
              <Label
                medium
                left
                text={selectedState.internationalCommunities}
              />
            </div>
          ) : (
              <div title={intl.formatMessage({ id: "international-community" })}>
                <Label
                  medium
                  left
                  text={selectedState.internationalCommunities}
                />
              </div>
            )}
        </TabView>
      </div>
    );
  }
}
export default injectIntl(DetailsOverview);
